var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.783 21.034H2.332a1 1 0 0 1-.856-1.517L11.2 3.448a1 1 0 0 1 1.711 0l9.726 16.069a1 1 0 0 1-.854 1.517",
    className: "up_svg__uparrow"
  })));
};
export { SvgUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDx0aXRsZT5hcnJvdy1idXR0b24tdXAtMjwvdGl0bGU+CiAgICA8cGF0aCBjbGFzcz0idXBhcnJvdyIgZD0iTTIxLjc4MywyMS4wMzRIMi4zMzJhMSwxLDAsMCwxLS44NTYtMS41MTdMMTEuMiwzLjQ0OGExLDEsMCwwLDEsMS43MTEsMGw5LjcyNiwxNi4wNjlBMSwxLDAsMCwxLDIxLjc4MywyMS4wMzRaIi8+Cjwvc3ZnPg==";